import ArticleLayout from '@/pages/article/components/ArticleLayout';
import { allArticles } from '@/mocks/articles';

export default function ArticlePage() {
  const article = allArticles.find(a => a.slug === 'sugargoo-spreadsheet-guide')!;
  return <ArticleLayout article={article} />;
}